import { useState } from 'react';
import { useT } from '../i18n';
import { Icon } from './icons';

const KEY = 'am27.installHint';

/** Safari on an iPhone or iPad, in a tab (not opened from the home screen nor the app). */
function iosTab(): boolean {
  // The iPhone and iPad app (vite --mode app) is full screen already.
  if (import.meta.env.MODE === 'app') return false;
  const ios =
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const standalone =
    (navigator as Navigator & { standalone?: boolean }).standalone === true ||
    matchMedia('(display-mode: standalone), (display-mode: fullscreen)').matches;
  return ios && !standalone;
}

function dismissed(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Safari on an iPhone has no full screen for a page: its bars take a good part of a screen
 * held on its side. Added to the home screen the game opens full screen, on its side, like an
 * app (manifest.webmanifest): this card on the title screen says how, until it is closed.
 */
export function InstallHint() {
  const t = useT();
  const [shown, setShown] = useState(() => iosTab() && !dismissed());
  if (!shown) return null;
  return (
    <aside className="install-hint panel" role="note">
      <Icon name="phone" size={22} />
      <p>
        <strong>{t('install.title')}</strong>
        <span>{t('install.how')}</span>
      </p>
      <button
        type="button"
        className="icon-btn"
        title={t('hud.close')}
        onClick={() => {
          setShown(false);
          try {
            localStorage.setItem(KEY, '1');
          } catch {
            // Private mode: it shows again next time, nothing more.
          }
        }}
      >
        <Icon name="close" size={16} />
      </button>
    </aside>
  );
}
